module.exports = __webpack_public_path__ + "assets/media/drift_login_image.ae1c6865.png";